import { Col, Container, Row } from "react-bootstrap";
import Footer from "../../Content/Footer";

const script = document.createElement("script");
script.src = './dataVis.js';

function checkLightMode() {
    if (sessionStorage.getItem('lightMode') === 'true')  {
      return true
    }
  }

export default function DataVisualizer() {
    return (
        <>
            <Container className="text-center">
                <h1>Data Visualizer</h1>
                <canvas id='dataVis' className={checkLightMode() ? "lightMode" : "darkMode"} width={200} height={200}/>
                <Row>
                    <Col>
                        <p>Data 1</p>
                    </Col>
                    <Col>
                        <p>Here2</p>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <p>Here1</p>
                    </Col>
                    <Col>
                        <p>Here2</p>
                    </Col>
                    <Col>
                        <p>Here3</p>
                    </Col>
                </Row>
            </Container>
            <Footer testProps= { checkLightMode() ? "lightMode" : "darkMode" }/>
        </>
    )
}